import styled from 'styled-components';
import { Text } from '@lmn/design-system';
import { useTranslation } from '@/app/components/translations/Translation';
import { Icon } from '@/app/common/icons/Icon';
import { getMealPlanIncludedOptionKeys, MEAL_PLAN_INCLUDED_OPTIONS_TITLE_KEY } from './mealPlanIncludedOptions';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const OptionsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const OptionItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  & > img {
    flex-shrink: 0;
    margin-top: 2px;
  }
`;

/**
 * The meals and drinks a meal plan covers, one check-marked line per option — the body of the
 * meal plan info modal on both the Evo and the legacy room area. Only codes with copy are listed
 * (see getMealPlanIncludedOptionKeys); callers hide the info icon when this list would be empty.
 */
export function MealPlanIncludedOptionsList({ includedOptions }: { includedOptions?: readonly string[] }) {
  const { t } = useTranslation();
  const optionKeys = getMealPlanIncludedOptionKeys(includedOptions);

  return (
    <Container>
      <Text variant="Body" weight="bold">
        {t(MEAL_PLAN_INCLUDED_OPTIONS_TITLE_KEY)}
      </Text>
      <OptionsList data-testid="meal-plan-included-options">
        {optionKeys.map((optionKey) => (
          <OptionItem key={optionKey}>
            <Icon category="Semantics" name="icon-check" size={20} color="iconPrimary" alt="" />
            <Text variant="Body" forceTag="span">
              {t(optionKey)}
            </Text>
          </OptionItem>
        ))}
      </OptionsList>
    </Container>
  );
}
